import { createRequest } from "helpers/tools";

/**
 * Get BigQuery Lead Auth URL
 * @returns {Promise} Response with auth_url
 */
export const getBigqueryLeadAuthUrl = async () => {
    return await createRequest({
        suffix: `lead/service/bigquery/auth-url`,
        handleError: true,
        method: "get",
    });
};

/**
 * Authorize BigQuery Lead with OAuth code
 * @param {Object} payload - { code: string }
 * @returns {Promise} Response with install_id and projects
 */
export const bigqueryLeadAuthorize = async (payload) => {
    return await createRequest({
        suffix: `lead/service/bigquery/authorize`,
        handleError: true,
        method: "post",
        payload,
    });
};

/**
 * Get BigQuery Tables for a specific project and dataset
 * @param {string} project - Project ID
 * @param {string} dataset - Dataset name
 * @param {number} install_id - Install ID from authorize response
 * @returns {Promise} Response with tables array
 */
export const getBigqueryLeadTables = async (project, dataset, install_id) => {
    return await createRequest({
        suffix: `lead/service/bigquery/tables?project=${project}&dataset=${dataset}&install_id=${install_id}`,
        handleError: true,
        method: "get",
    });
};

/**
 * Store BigQuery Lead destination configuration
 * @param {Object} payload - { name, install_id, project, dataset, table }
 * @returns {Promise} Response with service_id, fields, and destination_id
 */
export const bigqueryLeadStore = async (payload) => {
    return await createRequest({
        suffix: `lead/service/bigquery/store`,
        handleError: true,
        method: "post",
        payload,
    });
};
